import { render, staticRenderFns } from "./TenderPlug.vue?vue&type=template&id=7d347839&scoped=true&"
import script from "./TenderPlug.vue?vue&type=script&lang=js&"
export * from "./TenderPlug.vue?vue&type=script&lang=js&"
import style0 from "./TenderPlug.vue?vue&type=style&index=0&id=7d347839&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d347839",
  null
  
)

export default component.exports